<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router';
import { useAirBulletin } from '../composables/useAirBulletin';
const route = useRoute();
const { previousDesign, isEmbed } = useAirBulletin();
</script>

<template>
  <footer v-if="!isEmbed" class="site-footer">
    <nav class="footer-nav" aria-label="Choose a design">
      <RouterLink
        class="button button-secondary design-switch"
        :to="{ name: previousDesign ? 'home' : 'previous-design', query: route.query }"
        >{{ previousDesign ? 'Current Design' : 'Previous Design' }}</RouterLink
      >
    </nav>
    <p>
      HazePun by
      <a href="https://www.linkedin.com/in/waihsuen/" target="_blank" rel="noopener">Wai Hsuen</a>
    </p>
  </footer>
  <footer v-else class="site-footer embed-footer">
    <p>
      <RouterLink :to="{ name: 'home', query: route.query }">HazePun</RouterLink> · Live Singapore
      PSI by region · Data: NEA
    </p>
  </footer>
</template>
